var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sal-filter-swatch" }, [
    _vm.filter.title
      ? _c("div", { staticClass: "col-12" }, [
          _c("p", { staticClass: "filter__label group__label" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.filter.title) } }),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "filter__options row no-gutters" },
      [
        _vm._l(_vm.filter.options, function (option) {
          return [
            _c(
              "div",
              { staticClass: "swatch-wrapper" },
              [
                _c("sal-filter-swatch-element", {
                  key: _vm.filter.key,
                  attrs: { name: _vm.filter.name, swatches: option },
                }),
              ],
              1
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }